import Phaser from "phaser";
import { Block } from "../entities/Block";
import { StageConfig } from "../data/StageConfig";

export class PhysicsSystem {
  private scene: Phaser.Scene;

  constructor(scene: Phaser.Scene) {
    this.scene = scene;
  }

  /** Apply X-direction impulse to a block */
  applySwipeImpulse(block: Block, deltaX: number): void {
    const force = deltaX * StageConfig.impulseMultiplier;
    block.applyImpulseX(force);
  }

  /** Check if a block has escaped the screen */
  hasEscaped(block: Block): boolean {
    const centerX = this.scene.cameras.main.centerX;
    return Math.abs(block.getX() - centerX) > StageConfig.escapeXThreshold;
  }

  /** Check if a body has fallen off screen (Y check) */
  hasFallenOff(block: Block, screenHeight: number): boolean {
    return block.getY() > screenHeight + 100;
  }
}
